import { createStyles, Typography, withStyles, WithStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

import MHSkeleton from 'src/components/MHSkeleton';

import { DAY_NAMES } from '../../constants';
import { AvailableHourRange } from '../../models/Sessions';
import { colors } from '../../themes/colors';

const styles = () =>
  createStyles({
    dayContainer: {
      flex: 0,
      display: 'flex',
      flexDirection: 'row',
      marginTop: 5,
      marginBottom: 5,
      alignItems: 'center',
    },
    dayAbbreviation: {
      color: colors.purple1,
      fontWeight: 900,
      fontSize: 12,
      width: 38,
      height: 28,
      borderRadius: 14,
      marginRight: 5,
      marginLeft: 5,
      textAlign: 'center',
      paddingTop: 3,
    },
    availableHourRanges: {
      fontWeight: 100,
      color: colors.black2,
    },
  });

enum AvailableDayLineTestID {
  ContainerPrefix = 'AvailableDayLineTestID.ContainerPrefix',
  TimeRangePrefix = 'AvailableDayLineTestID.TimeRangePrefix',
}

interface Props extends WithStyles<typeof styles> {
  dayName?: string;
  availableHourRanges?: AvailableHourRange[];
  loading?: boolean;
}

const AvailableDayLine: React.FC<Props> = ({
  dayName = '',
  availableHourRanges = [],
  classes,
  loading = false,
}) => {
  if (!loading && (!dayName || availableHourRanges.length === 0)) {
    return null;
  }

  return (
    <div
      className={classes.dayContainer}
      data-testid={`${AvailableDayLineTestID.ContainerPrefix}${dayName}`}
    >
      {loading ? (
        <>
          <MHSkeleton width="8" height="5" backgroundColor="gray-275" className="float-left mr-2" />
          <MHSkeleton backgroundColor="gray-275" width="9/12" />
        </>
      ) : (
        <>
          <div className={classes.dayAbbreviation}>
            <Typography>{DAY_NAMES[dayName]}</Typography>
          </div>
          <div className={classes.availableHourRanges}>
            {availableHourRanges.map((range, index) => (
              <Typography
                style={{ fontSize: 12 }}
                key={`${range.start}${range.end}`}
                data-testid={`${AvailableDayLineTestID.TimeRangePrefix}${dayName}-${index}`}
              >
                {moment(range.start, 'HH:mm').format('h:mm A')} -{' '}
                {moment(range.end, 'HH:mm').format('h:mm A')}
              </Typography>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(AvailableDayLine);
